var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-pagination',{staticClass:"app-pagination",attrs:{"current-page":_vm.list.current_page,"page-size":_vm.size,"total":_vm.list.total,"layout":"total, prev, pager, next"},on:{"current-change":_vm.changeIndex}})}
var staticRenderFns = []

export { render, staticRenderFns }